var map = {
	"./img_banner_project_0.jpg": "8dbd3",
	"./img_banner_project_1.jpg": "9eff",
	"./img_banner_project_2.jpg": "16e6",
	"./img_banner_project_lingquan.jpg": "d08b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af29";